import styled from 'styled-components';
import theme from '@/data/theme';

const StyledAdminLoginForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  margin: 10px;
  gap: 12px;
  background: ${theme.colors.white};
  padding: 20px 12px;
  border-radius: 20px;
  box-shadow: 0 0 8px 0 rgba(134, 92, 208, 0.2);
`;

const StyledText = styled.p`
  color: #6b7280;
`;

const StyledErrorSpan = styled.span`
  color: ${theme.colors.danger};
`;

export { StyledAdminLoginForm, StyledText, StyledErrorSpan };
